"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractColors = exports.compose = exports.convertPixelsToRems = exports.capitalize = exports.toCSSVarTokenWithValue = exports.alphenColor = exports.lightenColor = exports.getHSLARawColor = exports.getHEXAColor = exports.humanizeColor = void 0;
var color_1 = __importDefault(require("color"));
var utils_1 = require("./utils");
/**
 * Convert color to hex or rgba for alpha channel
 *
 * @param clr color string to convert
 */
var humanizeColor = function (clr) {
    var color = (0, color_1.default)(clr);
    var hue = Number(color.hue().toPrecision(3));
    var saturatione = Number(color.saturationl().toPrecision(3));
    var lightness = Number(color.lightness().toPrecision(3));
    var alpha = Number(color.alpha().toPrecision(3));
    var hslColor = color_1.default.hsl(hue, saturatione, lightness, alpha);
    if (alpha === 1) {
        return hslColor.hex().toString();
    }
    return hslColor.rgb().toString();
};
exports.humanizeColor = humanizeColor;
var getHEXAColor = function (clr) {
    try {
        return (0, color_1.default)(clr).hexa().toString();
    }
    catch (error) {
        return clr;
    }
};
exports.getHEXAColor = getHEXAColor;
var getHSLARawColor = function (clr) {
    try {
        var alpha = Math.round((0, color_1.default)(clr).hsl().alpha() * 100) / 100;
        var rounded = Number(alpha.toFixed(2));
        return (0, color_1.default)(clr).hsl().alpha(rounded).round();
    }
    catch (error) {
        return (0, color_1.default)('#FFFFFF');
    }
};
exports.getHSLARawColor = getHSLARawColor;
/**
 * Осветлить/затемнить на x процентных пунктов.
 */
var lightenColor = function (color, value) {
    var hsl = (0, color_1.default)(color).hsl();
    var res = hsl.lightness(hsl.lightness() + value);
    if (res.alpha() === 1) {
        return res.hex().toString();
    }
    return res.rgb().toString();
};
exports.lightenColor = lightenColor;
/**
 * Изменить непрозрачность цвета на x.
 */
var alphenColor = function (color, value, format, isRaw) {
    if (format === void 0) { format = 'rgba'; }
    if (isRaw === void 0) { isRaw = false; }
    var rgb = (0, color_1.default)(color).rgb();
    var newColor = rgb.alpha(rgb.alpha() + value).toString();
    if (format === 'hexa' && isRaw) {
        return (0, exports.getHEXAColor)(newColor);
    }
    if (format === 'hexa' && !isRaw) {
        return (0, exports.getHEXAColor)((0, exports.humanizeColor)(newColor));
    }
    if (format === 'rgba' && isRaw) {
        return newColor;
    }
    return (0, exports.humanizeColor)(newColor);
};
exports.alphenColor = alphenColor;
/**
 * Переведет пиксели в ремы.
 * @param {string} value
 * @param {number} basis По-умолчанию взято 16, потому что предполагается скалирование
 * на уровне тега html, кратное 16.
 * @return {string}
 */
var toRem = function (value, basis) {
    if (basis === void 0) { basis = 16; }
    if (typeof value === 'string') {
        value = parseInt(value.replace(/\D+$/, ''), 10);
    }
    return "".concat(value / basis, "rem");
};
/**
 * Преобразует название и значение токена в CSS Var.
 * @param {string} name
 * @param {string|number} value
 * @param {withDesignPrefix|undefined} withDesignPrefix
 * @return {string}
 */
var toCSSVarTokenWithValue = function (name, value, withDesignPrefix) {
    return value
        ? "var(".concat((0, utils_1.getCSSVariableName)(name, withDesignPrefix), ", ").concat((0, utils_1.escapeValue)(value), ")")
        : "var(".concat((0, utils_1.getCSSVariableName)(name, withDesignPrefix), ")");
};
exports.toCSSVarTokenWithValue = toCSSVarTokenWithValue;
// ToDo: перенести в новый пакет, plasma-utils, где шарится код между всеми компонентами, токенами, утилитами
var capitalize = function (str) { return str[0].toUpperCase() + str.slice(1); };
exports.capitalize = capitalize;
/**
 * Конвертация значений fontSize и lineHeight из пикселей в ремы.
 * @param {TypographStyle} style
 * @return {TypographStyle}
 */
var convertPixelsToRems = function (style) {
    if (style.fontSize.indexOf('px') !== -1) {
        style.fontSize = toRem(style.fontSize);
    }
    if (style.lineHeight && style.lineHeight.indexOf('px') !== -1) {
        style.lineHeight = toRem(style.lineHeight);
    }
    return style;
};
exports.convertPixelsToRems = convertPixelsToRems;
/**
 * Композиция функций.
 */
var compose = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.reduceRight(function (prevFn, nextFn) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return nextFn(prevFn.apply(void 0, args));
    }; }, function (value) { return value; });
};
exports.compose = compose;
/**
 * Извлечение цвета и прозрачности из ссылочного токена.
 *  @example '[genera.red.500][-0.99]' => ['genera.red.500', '-0.99']
 *  @example '[genera.red.500]' => ['genera.red.500']
 */
var extractColors = function (value) { return /\[(.*?)\](?:\[(.*?)\])?/g.exec(value) || []; };
exports.extractColors = extractColors;
//# sourceMappingURL=functions.js.map